module.exports = __webpack_public_path__ + "static/media/Instagram.da43410b.svg";